function homePage() {
  $('.home-slider__slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
  });

  $('.post-slider-wrapper:not(.catalog) .post-slider').slick({
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 999999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }
    ],
  });

  $('.catalog .post-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 999999,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
        }
      }
    ],
  });

  $('.videos-slider').slick({
    arrows: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30px',
    responsive: [
      {
        breakpoint: 1024,
        settings : 'unslick'
      }
    ]
  })

  //Custom slick arrows
  $('.prev-arrow').click(function() {
    $(this).closest('.post-slider-wrapper').find('.post-slider').slick('slickPrev');
  });

  $('.next-arrow').click(function() {
    $(this).closest('.post-slider-wrapper').find('.post-slider').slick('slickNext');
  });
}

export { homePage };
